import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "../../hooks/useTranslation";
import { useModal } from "@refinedev/core";
interface DiscardButtonProps {
  reset: () => void;
  isDirty: boolean;
}

export const DiscardButton = ({ reset, isDirty }: DiscardButtonProps) => {
  const { translateWithoutPrefix } = useTranslation();
  const { visible, show, close } = useModal();
  return (
    <>
      <Button disabled={!isDirty} variant="outlined" onClick={show}>
        {translateWithoutPrefix("common.components.discard.discard")}
      </Button>
      <Dialog open={visible}>
        <DialogTitle>
          {translateWithoutPrefix("common.components.discard.confirmDiscard")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {translateWithoutPrefix(
              "common.components.discard.areYouSureDiscard",
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={close} variant="outlined">
            {translateWithoutPrefix("buttons.discard")}
          </Button>
          <Button
            onClick={() => {
              reset();
              close();
            }}
            variant="contained"
          >
            {translateWithoutPrefix("common.components.discard.confirmDiscard")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
